import { createColumnHelper } from '@tanstack/react-table'
import { IoIdCard } from 'react-icons/io5'
import { EmptyCell } from 'uikit/ReactTable/cells/EmptyCell'
import { ItemIcon } from 'uikit/Snippets'

export type ItemBySovcomClientId = {
  fullName: string
  clientId: string
  mainPhone: string
  seriesAndNumber: string
  accountNumber: string
  contractNumber: string
}

const columnHelper = createColumnHelper<ItemBySovcomClientId>()

export const columns = [
  columnHelper.display({
    id: 'icon',
    cell: () => <ItemIcon w="60px" IconComponent={IoIdCard} badge={null} />,
    minSize: 60,
    maxSize: 60,
    enableHiding: false,
  }),
  columnHelper.accessor('fullName', {
    header: 'ФИО',
    minSize: 200,
    maxSize: 250,
    cell: (info) => info.getValue() || <EmptyCell />,
  }),
  columnHelper.accessor('clientId', {
    header: 'ClientID',
    minSize: 120,
    maxSize: 150,
    cell: (info) => info.getValue() || <EmptyCell />,
  }),
  columnHelper.accessor('mainPhone', {
    header: 'Телефон',
    minSize: 120,
    maxSize: 150,
    cell: (info) => {
      return info.getValue() || <EmptyCell />
    },
  }),
  columnHelper.accessor('seriesAndNumber', {
    header: 'Паспорт',
    minSize: 120,
    maxSize: 150,
    cell: (info) => info.getValue() || <EmptyCell />,
  }),
  columnHelper.accessor('accountNumber', {
    header: 'Номер счета',
    minSize: 100,
    maxSize: 250,
    cell: (info) => info.getValue() || <EmptyCell />,
  }),
  columnHelper.accessor('contractNumber', {
    header: 'Номер договора',
    minSize: 100,
    maxSize: 250,
    cell: (info) => info.getValue() || <EmptyCell />,
  }),
]
